import autobind from 'core-decorators/lib/autobind';
import { VODCSSModules } from 'shared/utils/wix-connect';

import MenuButton from 'widget/views/desktop/compact/components/menu-button/menu-button';
import Animate from 'widget/views/desktop/compact/components/animate/animate';

import styles from './action-bar.styl';


@VODCSSModules(styles)
export default class ActionBar extends React.Component {

  static propTypes = {
    children: React.PropTypes.any,
    height: React.PropTypes.number,
    areActionsVisible: React.PropTypes.bool,

    onActionsContainerClick: React.PropTypes.func,

    onMenuClick: React.PropTypes.func,
    onButtonsClick: React.PropTypes.func,
  };

  @autobind
  handleButtonsClick(event) {
    event.stopPropagation();
    this.props.onButtonsClick();
  }

  renderButtons() {
    const { onActionsContainerClick, children } = this.props;

    return (
      <div onClick={onActionsContainerClick}
           className={styles['clickable-container']}>
        <div styleName="buttons"
             onClick={this.handleButtonsClick}>
          {children}
        </div>
      </div>
    );
  }

  renderMenuButton() {
    const { onMenuClick } = this.props;

    return (
      <div className={styles['clickable-container']}
           onClick={onMenuClick}>
        <MenuButton styleName="menu-button" />
      </div>
    );
  }

  render() {
    const { areActionsVisible, height } = this.props;

    return (
      <section style={{ height }}
               styleName="actions">
        <Animate activeClassName={styles['actions-wrapper']}
                 dataHook="compactActions"
                 type="fade-in"
                 when={areActionsVisible}>
          {this.renderButtons()}
        </Animate>
        <Animate type="fade-in"
                 activeClassName={styles['menu-button-wrapper']}
                 dataHook="menuButtonWrapper"
                 when={!areActionsVisible}>
          {this.renderMenuButton()}
        </Animate>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/action-bar/action-bar.js